import type { FC } from "react"
import { BrowserRouter, Navigate, Route } from "react-router"

import { AuthenticatedLayout } from "./authenticated-layout"
import { MetaTags } from "./components/MetaTags"
import { ErrorPage } from "./error-page"
import { GlobalLayout } from "./global-layout"
import { LoggedOutLayout } from "./logged-out-layout"
import {
  AccountSettings,
  CardManagement,
  ForgetPassword,
  ForgetPasswordSent,
  GuestPurchase,
  GuestPurchaseCard,
  GuestPurchaseLayout,
  GuestPurchaseReturn,
  GuestTicketView,
  Home,
  Login,
  NotFound,
  PurchaseDetail,
  PurchaseLog,
  PurchaseUse,
  ResetPassword,
  Restaurant,
  RestaurantTicketDetail,
  SignUp,
  TicketPurchase,
  TicketPurchaseCard,
  TicketPurchaseLayout,
  TicketPurchaseReturn,
  UpdateEmail,
  UpdatePassword,
} from "./routes"
import { SentryRoutes } from "./sentry"

export const Routes: FC = () => {
  return (
    <BrowserRouter>
      <MetaTags />
      <SentryRoutes>
        <Route element={<GlobalLayout />} errorElement={<ErrorPage />}>
          <Route element={<LoggedOutLayout />}>
            <Route path="login" element={<Login />} />
            <Route path="signup" element={<SignUp />} />
          </Route>

          <Route path="login/forget-password" element={<ForgetPassword />} />
          <Route path="login/forget-password/sent" element={<ForgetPasswordSent />} />
          <Route path="login/reset-password" element={<ResetPassword />} />

          <Route index element={<Home />} />
          <Route path="not-found" element={<NotFound />} />
          <Route path="restaurants">
            <Route path=":restaurantId" element={<Restaurant />} />
            <Route path=":restaurantId">
              <Route path="tickets">
                <Route path=":ticketId" element={<RestaurantTicketDetail />} />
              </Route>
            </Route>
          </Route>
          <Route path="ticket" element={<GuestTicketView />} />

          <Route path="restaurants">
            <Route path=":restaurantId">
              <Route path="tickets">
                <Route path=":ticketId">
                  <Route element={<TicketPurchaseLayout />}>
                    <Route path="purchase" element={<TicketPurchase />} />
                    <Route path="purchase/card" element={<TicketPurchaseCard />} />
                  </Route>
                  <Route path="purchase/return" element={<TicketPurchaseReturn />} />
                  <Route path="guest-purchase" element={<GuestPurchaseLayout />}>
                    <Route index element={<GuestPurchase />} />
                    <Route path="card" element={<GuestPurchaseCard />} />
                  </Route>
                  <Route path="guest-purchase/return" element={<GuestPurchaseReturn />} />
                </Route>
              </Route>
            </Route>
          </Route>

          <Route path="purchases">
            <Route index element={<PurchaseLog />} />
            <Route path=":id" element={<PurchaseDetail />} />
            <Route path=":id/use" element={<PurchaseUse />} />
          </Route>
          <Route path="account">
            <Route index element={<AccountSettings />} />
          </Route>

          <Route element={<AuthenticatedLayout />}>
            <Route path="account">
              <Route path="mail" element={<UpdateEmail />} />
              <Route path="password" element={<UpdatePassword />} />
              <Route path="card" element={<CardManagement />} />
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/not-found" replace />} />
        </Route>
      </SentryRoutes>
    </BrowserRouter>
  )
}
